import React, { useEffect, useRef } from 'react';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

import styles from './nav-search.styles.css';
import { getPhoneFormat } from './nav-search.helper';
import { useHighlighter } from 'canopy-styleguide!sofe'

export const SearchResultItem = ({
  item,
  category,
  displayKey,
  closeNav,
  searchTerm,
  link,
  hoverIndex,
}) => {
  const curItem = useRef();
  const getDisplayValue = useHighlighter(category.isPhone ? getPhoneFormat(item.value) : item.value, searchTerm);
  useEffect(() => {
    if (item.itemIndex === hoverIndex) {
      scrollIntoViewIfNeeded(curItem.current, { behavior: 'smooth', scrollMode: 'if-needed' });
    }
  }, [item.itemIndex, hoverIndex]);

  return (
    <li
      key={item.id}
      ref={curItem}
      className={`cp-mt-8 cp-pl-8 ${styles.searchLink} ${item.itemIndex === hoverIndex ? styles.isHovered : ''}`}>
      <a tabIndex={-1} href={link(item) || ''} onClick={closeNav}>
        <div>
          <div className="cps-ellipsis cps-wt-semibold">{getDisplayValue}</div>
          <div className="cps-ellipsis cps-caption" style={{ whiteSpace: 'nowrap' }}>
            <i>{item[displayKey]}</i>
          </div>
        </div>
      </a>
    </li>
  );
};
